import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        minWidth: '100vw',
    },
    wrapper: {
        border: 'solid 1px #e74c3c',
        maxWidth: 700,
        padding: '64px 128px',
        margin: 24,
    },
    title: {
        fontSize: 24,
        marginBottom: 32,
    },
})

export const InternetExplorer = () => {
    const styles = useStyles()
    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>
                <h1 className={styles.title}>Navigateur non supporté</h1>
                <p>
                    L'application TelePod n'est pas compatible avec Internet
                    Explorer.
                </p>
                <p>
                    Merci de visiter cette dernière avec un navigateur moderne.
                </p>
            </div>
        </div>
    )
}

export const useInternetExplorer = () => {
    const { userAgent } = window.navigator
    return /MSIE|Trident/.test(userAgent)
}
